exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".og-image[data-v-2173ef7c]{-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center}.remove-button[data-v-2173ef7c]{z-index:1021}", ""]);

// exports
